import { useMemo } from 'react';
import { useGetClientConfiguration } from 'services/configuration';

export const useClientMode = () => {
  const configuration = useGetClientConfiguration();

  const isActive = useMemo(
    () => configuration.data?.passive === false,
    [configuration.data?.passive]
  );

  return { isActive };
};
